<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>反馈管理</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'feedbackList' }"
          >反馈列表</el-breadcrumb-item
        >
        <el-breadcrumb-item>反馈详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <div class="feedback-box" v-loading="formLoading">
        <el-form style="width: 95%;" :model="detailParams" label-width="120px">
          <el-form-item label="反馈用户：">
            <span>{{ detailParams.creator }}</span>
          </el-form-item>

          <el-form-item label="反馈时间：">
            <span>{{ detailParams.publishTime | formatDate(true) }}</span>
          </el-form-item>

          <el-form-item label="反馈标题：">
            <span>{{ detailParams.title }}</span>
          </el-form-item>

          <el-form-item label="反馈内容：">
            <p>{{ detailParams.content }}</p>
          </el-form-item>

          <el-form-item label="反馈模块：">
            <span>{{ detailParams.category }}</span>
          </el-form-item>

          <el-form-item label="接收单位：">
            <span>{{ detailParams.receiver }}</span>
          </el-form-item>
          <el-form-item v-if="detailParams.imageUrlList" label="回复截图：">
            <el-image
              v-for="(img, index) in detailParams.imageUrlList"
              :key="index"
              style="width: 100px; height: 100px;margin-right:10px"
              :src="img"
              :preview-src-list="detailParams.imageUrlList"
            >
            </el-image>
          </el-form-item>

          <div v-for="(item, index) in detailParams.msgList" :key="index">
            <div class="division-cut-line"></div>
            <el-form-item label="回复时间：">
              <span>{{ item.publishTime | formatDate(true) }}</span>
            </el-form-item>

            <el-form-item label="回复人：">
              <span>{{ item.sender }}</span>
            </el-form-item>

            <el-form-item label="回复内容：">
              <span>{{ item.content }}</span>
            </el-form-item>
            <el-form-item v-if="item.imageUrlList" label="回复截图：">
              <el-image
                v-for="(img, index) in item.imageUrlList"
                :key="index"
                style="width: 100px; height: 100px;margin-right:10px"
                :src="img"
                :preview-src-list="item.imageUrlList"
              >
              </el-image>
            </el-form-item>
          </div>

          <div class="division-cut-line"></div>

          <el-form-item
            style="position: relative;"
            label="回复："
            prop="content"
          >
            <el-input
              v-model="content"
              type="textarea"
              :row="6"
              placeholder="请输入回复内容"
              class="mgb10"
            >
            </el-input>
            <el-button
              :disabled="isDisabled"
              class="reply-btn"
              type="text"
              @click="replyFeedback"
            >
              回 复
            </el-button>
          </el-form-item>

          <el-form-item class="mgt20 align-center">
            <el-button
              size="small"
              @click="$router.push({ name: 'feedbackList' })"
            >
              返 回
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      topicId: 0,
      formLoading: false,
      detailParams: {
        creator: "",
        publishTime: "",
        title: "",
        content: "",
        category: "",
        receiver: "",
        msgList: []
      },
      content: "",
      isDisabled: false
    };
  },
  mounted() {
    this.loadDetailList();
  },
  methods: {
    /**
     * 初始化详情页数据
     */
    loadDetailList() {
      const topicId = this.$route.query.topicId;
      this.topicId = topicId;
      if (topicId) {
        this.formLoading = true;
        this.$http({
          url: global.apiUrl + `/feedback/topic/${topicId}/msg`,
          method: "GET"
        })
          .then(res => {
            this.formLoading = false;
            if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
              Object.assign(this.detailParams, res.body.data);
            } else {

            }
          })
          .catch(err => {
            this.formLoading = false;

            console.error(err);
          });
      }
    },
    /**
     * 回复反馈
     */
    replyFeedback() {
      this.isDisabled = true;
      if (this.content) {
        this.$http({
          url: global.apiUrl + `/feedback/topic/${this.topicId}/msg`,
          method: "POST",
          body: {
            content: this.content
          }
        })
          .then(res => {
            this.isDisabled = false;
            if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
              this.$message.success(res.body.info);
              this.content = "";
              this.loadDetailList();
            } else {

            }
          })
          .catch(err => {
            this.isDisabled = false;

            console.error(err);
          });
      } else {
        this.$message.error("回复内容不能为空");
        this.isDisabled = false;
      }
    }
  }
};
</script>

<style lang="less" scoped>
.home-container {
  .hx-form-container {
    .feedback-box {
      width: 95%;
      margin: auto;
      .el-form {
        .el-form-item {
          margin-bottom: 0;
          .reply-btn {
            position: absolute;
            right: 20px;
          }
        }
      }
      .division-cut-line {
        width: 95%;
        height: 1px;
        background-color: rgba(0, 0, 0, 0.1);
        margin: 10px auto;
      }
    }
  }
}
</style>
